import { useUsers } from '../../../state/entities'
import useUserSuggestions from '../../../state/queries/useUserSuggestions'
import formikConnectedMultiItemSelect from '../../basics/ItemSelect/formikConnectedMultiItemSelect'
import multiItemSelect from '../../basics/ItemSelect/multiItemSelect'

/**********************************************************************
 * SelectUsers
 **********************************************************************/
const SelectUsers = multiItemSelect({
  multiSelect: true,
  useSuggestions: useUserSuggestions,
  renderItemDescription: (user) => `${user.firstname} ${user.lastname}`,
})

export default SelectUsers

/**********************************************************************
 * SelectUsersFormik
 **********************************************************************/
export const SelectUsersFormik = formikConnectedMultiItemSelect({
  component: SelectUsers,
  useItems: (uuids) => useUsers(uuids).users,
  mapItems: (users) => users.map(({ uuid }) => uuid),
})
